// frontend/src/screens/ProjectsScreen2.jsx
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useGetProjects2Query } from '../slices/projectsApiSlice';
import ScrollToHashElement from '@cascadia-code/scroll-to-hash-element';

// import Typography from '@mui/material/Typography';
// import Accordion from 'react-bootstrap/Accordion';
import {
  Accordion as Accordion2,
  Card,
  CardHeader,
  Paper,
  Stack,
  styled,
} from '@mui/material';
import {
  AccordionSummary,
  Box,
  Divider,
  LinearProgress,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentType,
  setViewInvisible,
  setShowCreatedAt,
  setFinancingMarkerMode,
  setShowMortgageUnderline,
} from '../slices/modeSlice';
import { useUpdateLinkOfStageAndProjectMutation } from '../slices/pslinkApiSlice';
import Alerton from '../components/Alerton';
import AccordionDetails from '@mui/material/AccordionDetails';
import ProjectRowV2 from '../components/ProjectRowV2';
import TypeHeader from '../components/TypeHeader2';
import { setColor } from '../store/constant';
import NewsList from '../components/NewsList';
import ScreenContainer from '../components/ScreenContainer';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CloseIcon from '@mui/icons-material/Close';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import BorderBottomIcon from '@mui/icons-material/BorderBottom';

// Варианты остаются в коде для возможного возврата после оценки заказчиком.
const SHOW_FINANCING_DISPLAY_CONTROLS = false;

// import Fade from '@mui/material/Fade';

const SumBox = styled(Paper)(({ theme, state, visible }) => ({
  backgroundColor:
    setColor[visible][theme.palette.mode][state === '' ? 'default' : state][
      'bg'
    ],
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  // paddingTop: theme.spacing(py),
  // paddingBottom: theme.spacing(py),
  //marginRight: theme.spacing(1),
  textAlign: 'center',
  color:
    setColor[visible][theme.palette.mode][state === '' ? 'default' : state][
      'color'
    ],
  cursor: 'pointer',
}));

const ProjectsScreen = () => {
  const { state, hash } = useLocation();
  const { section } = useParams();
  // console.log('section', section);

  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [message, setMessage] = useState('');

  // const [showCreatedAt, setShowCreatedAt] = useState(false);
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const { userInfo, permissions } = useSelector((state) => state.auth);
  const canSetStages = userInfo?.isAdmin || !!permissions?.crm?.setStages;
  const canResetStages = userInfo?.isAdmin || !!permissions?.crm?.resetStages;
  const canReadNews = userInfo?.isAdmin || !!permissions?.news?.read;

  const [updateLinkOfStageAndProject] =
    useUpdateLinkOfStageAndProjectMutation();
  const [switchProgress, setSwitchProgress] = useState(''); //projectId
  const {
    currentType,
    showStages,
    showCreatedAt,
    financingMarkerMode = 'inline',
    showMortgageUnderline = false,
    // sortByType,
    viewInvisible,
    currentSort,
    searchString,
  } = useSelector((state) => state.mode);
  // Принятый вид одинаков для всех, включая браузеры со старым сохранённым выбором.
  const activeFinancingMarkerMode = SHOW_FINANCING_DISPLAY_CONTROLS ? financingMarkerMode : 'inline';
  const activeMortgageUnderline = SHOW_FINANCING_DISPLAY_CONTROLS ? showMortgageUnderline : false;

  const { data, refetch, isLoading, isError, error, isFetching } =
    useGetProjects2Query(
      {
        viewInvisible,
        sortBy: currentSort?.id,
        searchString,
        section,
      },
      {
        refetchOnMountOrArgChange: true, // Авто-refetch при смене section
      },
    );

  // useEffect(() => {
  //   // console.log('currentSort', currentSort);
  //   console.log('data', data);
  // }, [data]);

  // let userRoles = [];
  // if (Array.isArray(data?.userRoles) && data?.userRoles.length > 0) {
  //   userRoles = data.userRoles;
  // }

  // const setShowStages = () => {
  //   dispatch(setVisibilityStages(!showStages));
  // };

  const handleSwitchTurn = async (relevationId, state, projectId, visible) => {
    if (!canSetStages) {
      return;
    }
    const nextState = state === '' ? 'start' : state === 'start' ? 'done' : '';
    if (nextState === '' && !canResetStages) {
      return;
    }

    const payload = {
      linkId: relevationId,
      state: nextState,
    };

    // console.log(relevationId, state, projectId, visible);
    // console.log('payload', payload);
    // return;
    if (visible) {
      setSwitchProgress(projectId);
      try {
        await updateLinkOfStageAndProject(payload).unwrap();
        setSwitchProgress('');
        refetch();
      } catch (error) {
        console.log(error);
        setMessage(
          error?.data?.message || error?.error || error?.message || error,
        );
      }
    }
  };

  const handleCloseMessage = () => {
    setMessage('');
  };

  const handleChangeViewInvisible = (param) => {
    //setViewInvisible(param);
    dispatch(setViewInvisible(param));
    refetch();
  };

  // const setShowSortedByType = () => {
  //   dispatch(setSortByType(!sortByType));
  // };

  const handleSetShowCreatedAt = () => {
    // setShowCreatedAt(!showCreatedAt);
    dispatch(setShowCreatedAt(!showCreatedAt));
  };

  const goto = (id) => {
    if (section) {
      navigate(`/crm/${section}/${id}`);
    } else {
      navigate(`/projects/v2/${id}`);
    }
  };

  useEffect(() => {
    if (state?.refetch) {
      //window.location.reload();
      refetch();
    }
    //eslint-disable-next-line
  }, [state]);

  // console.log('currentArg', currentArg);

  // БЛОКИРУЕМ старый data, если section не совпадает
  if (isFetching || isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return (
      <Alert severity='warning'>{error?.data?.message || error.error}</Alert>
    );
  }

  // if (isLoading) {
  //   return <CircularProgress />;
  // } else if (isError) {
  //   return (
  //     <Alert severity='warning'>{error?.data?.message || error.error}</Alert>
  //   );
  // }

  const handleExpansion = (typeId) => {
    if (currentType === typeId) {
      dispatch(setCurrentType(''));
    } else {
      dispatch(setCurrentType(typeId));
    }
  };

  const palette = theme.palette;

  // const buttons = [
  //   {
  //     label: currentSort?.title,
  //     component: <SortMenu refetch={refetch} />,
  //   },
  // ];

  const getTypeSummary = (typeId) => {
    if (Array.isArray(data?.typeSummary)) {
      const result = data?.typeSummary
        .filter((type) => type._id === typeId)
        .map((type, index) => {
          return (
            <Stack direction='row' spacing={1} key={index}>
              {type?.done ? (
                <SumBox
                  theme={theme}
                  visible={'true'}
                  state='done'
                  sx={{
                    border: `1px solid ${palette.warning}`,
                    minWidth: '35px',
                  }}
                >
                  {type?.done}
                </SumBox>
              ) : null}
              {type?.start ? (
                <SumBox
                  theme={theme}
                  visible={'true'}
                  state='start'
                  sx={{
                    border: `1px solid ${palette.warning}`,
                    minWidth: '35px',
                  }}
                >
                  {type?.start}
                </SumBox>
              ) : null}
              {type?.wait ? (
                <SumBox
                  theme={theme}
                  visible={'true'}
                  state=''
                  sx={{
                    border: `1px solid ${palette.warning}`,
                    minWidth: '35px',
                  }}
                >
                  {type?.wait}
                </SumBox>
              ) : null}
              {type?.unpaid ? (
                <SumBox
                  theme={theme}
                  visible={'false'}
                  state=''
                  sx={{
                    border: `1px solid ${palette.warning}`,
                    minWidth: '35px',
                  }}
                >
                  {type?.unpaid}
                </SumBox>
              ) : null}
            </Stack>
          );
        });

      return result;
    }
  };

  const upButtons = [
    {
      title: 'Создать новый этап',
      onClick: () => {
        if (section) {
          navigate(`/crm/${section}/edit/new`);
        } else {
          navigate('/projects/v2/edit/new');
        }
      },
      type: 'icon',
      icon: <AddIcon />,
      xs: 2,
      position: 'left',
    },
    {
      title: 'Показать скрытые',
      onClick: () => {
        handleChangeViewInvisible(!viewInvisible);
      },
      type: 'icon',
      icon: viewInvisible ? <VisibilityOffIcon /> : <VisibilityIcon />,
      xs: 2,
      position: 'left',
    },
    {
      title: 'Показ даты',
      onClick: () => {
        handleSetShowCreatedAt(!showCreatedAt);
      },
      type: 'icon',
      icon: showCreatedAt ? <CalendarMonthIcon /> : <CalendarTodayIcon />,
      xs: 2,
      position: 'left',
    },
    ...(SHOW_FINANCING_DISPLAY_CONTROLS ? [{
      title: financingMarkerMode === 'inline'
        ? 'Значок в строке — переключить на прежний бейдж'
        : 'Прежний бейдж — переключить на значок в строке',
      arialabel: financingMarkerMode === 'inline' ? 'Значок в строке' : 'Прежний бейдж',
      onClick: () => dispatch(setFinancingMarkerMode(financingMarkerMode === 'inline' ? 'badge' : 'inline')),
      type: 'icon',
      icon: financingMarkerMode === 'inline' ? <RadioButtonCheckedIcon /> : <BadgeOutlinedIcon />,
      color: financingMarkerMode === 'inline' ? 'primary' : 'inherit',
      position: 'left',
    },
    {
      title: showMortgageUnderline ? 'Скрыть красную линию ипотеки' : 'Показать красную линию ипотеки',
      arialabel: showMortgageUnderline ? 'Красная линия ипотеки включена' : 'Красная линия ипотеки выключена',
      onClick: () => dispatch(setShowMortgageUnderline(!showMortgageUnderline)),
      type: 'icon',
      icon: <BorderBottomIcon />,
      color: showMortgageUnderline ? 'error' : 'inherit',
      position: 'left',
    }] : []),
    {
      title: 'Закрыть',
      onClick: () => {
        if (state?.backUrl) {
          navigate(state.backUrl);
        } else {
          navigate(-1);
        }
      },
      type: 'icon',
      icon: <CloseIcon />,
      xs: 2,
      position: 'right',
    },
  ];

  return (
    <>
      <ScreenContainer buttons={upButtons} isProgress={isFetching}>
        <ScrollToHashElement inline='center' block='center' />
        <Card>
          <CardHeader
            title={data?.section?.title || 'Клиенты и объекты:'}
            // subheader={<>{hideHeader ? <Subheader filters={filters} /> : ''}</>}
            // action={
            //   <>
            //     {filters && Array.isArray(filters) && filters.length > 0 && (
            //       <IconButton onClick={() => setHideHeader(!hideHeader)}>
            //         {hideHeader ? <ExpandMoreIcon /> : <ExpandLessIcon />}
            //       </IconButton>
            //     )}
            //   </>
            // }
          ></CardHeader>
          {/* {isFetching && <LinearProgress sx={{ mb: 2 }} />} */}
          <Box
            sx={{
              width: '100%',
              // maxWidth: 700,
              bgcolor: 'background.paper',
              mb: 3,
            }}
          >
            {data.rows &&
              data.rows.map((type, index) => (
                <Accordion2
                  key={type._id}
                  expanded={type._id === currentType}
                  onChange={() => handleExpansion(type._id)}
                  // slots={{ transition: Fade }}
                  // slotProps={{ transition: { timeout: 10 } }}
                  //ExpandMoreIcon
                  sx={{
                    '& .MuiAccordion-region': {},
                    '& .MuiAccordionDetails-root': { padding: 0 },
                    background: 'none',
                    backgroundImage: 'none',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls='panel1-content'
                    id={`panel-header-${type._id}`}
                    sx={{
                      background:
                        theme.palette.mode === 'dark' ? '#1E1E1E' : '#F5F5F5',
                    }}
                    key={type._id}
                  >
                    <Stack
                      direction='row'
                      justifyContent='space-between'
                      alignItems='center'
                      width={'100%'}
                      sx={{ mr: 1 }}
                    >
                      <span>{`${type.title} (${type?.count})`}</span>
                      {getTypeSummary(type._id)}
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails
                  // sx={{ background: 'none', backgroundImage: 'none',  }}
                  >
                    <Box sx={{ px: 2 }}>
                      {Array.isArray(data?.summary) && (
                        <TypeHeader
                          stages={
                            data.summary.find((t) => t._id === type._id)?.stages
                          }
                          showStages={showStages}
                          matchDownMd={matchDownMd}
                          showCreatedAt={showCreatedAt}
                        />
                      )}
                      {Array.isArray(type?.projects) &&
                        type.projects.map((project, index) => (
                          <span key={index}>
                            <ProjectRowV2
                              hash={hash}
                              userInfo={userInfo}
                              project={project}
                              matchDownMd={matchDownMd}
                              showStages={showStages}
                              showCreatedAt={showCreatedAt}
                              financingMarkerMode={activeFinancingMarkerMode}
                              showMortgageUnderline={activeMortgageUnderline}
                              goto={goto}
                              palette={palette}
                              handleSwitchTurn={handleSwitchTurn}
                              canSetStages={canSetStages}
                            />
                            {switchProgress === project._id && (
                              <LinearProgress />
                            )}
                            <Divider />
                          </span>
                        ))}
                    </Box>
                  </AccordionDetails>
                </Accordion2>
              ))}
          </Box>
        </Card>
        {canReadNews && <NewsList section={section} />}
      </ScreenContainer>
      <Alerton message={message} handleCloseMessage={handleCloseMessage} />
    </>
  );
};

export default ProjectsScreen;
